import Marquee from "react-fast-marquee";

const items = [
  "ZATEPLENIE BUDOV",
  "PROFESIONÁLNA REALIZÁCIA",
  "RODINNÉ DOMY",
  "BYTOVÉ DOMY",
  "OVERENÍ PARTNERI",
  "DOTÁCIE OBNOV DOM",
];

export default function GoldMarquee() {
  return (
    <div className="py-8 md:py-10 bg-ink border-y border-white/10">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-5xl md:text-7xl text-stroke-gold px-8 tracking-wide leading-[1.3] py-2 inline-block">{t}</span>
            <span className="text-gold text-3xl px-2">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
